import React, { useContext } from 'react';
import CardBox from '../../../CardBox';
import CO2Img from './imgs/icon-co2@2x.png';
import RunStateImg from './imgs/icon-run-state@2x.png';
import styles from './index.module.scss';
import { useRequest } from 'ahooks';
import { apiV2MicrogridOverviewGetDataTotalViewPost } from '@maxtropy/intelligent-dispath-apis-v2';
import {
  formatCarbon,
  formatCarbonTotCO2,
  formatPower,
  keepTwoOrLine,
} from '@/pages/IndustrialGreenMicBigScreen/utils';
import { ShareDataContext } from '@/pages/IndustrialGreenMicBigScreen';
import { isNil } from 'lodash-es';

const DataScreening = () => {
  const { microgridId, dataExit } = useContext(ShareDataContext);
  const { data } = useRequest(() => apiV2MicrogridOverviewGetDataTotalViewPost({ id: microgridId }), {
    ready: !!microgridId,
    refreshDeps: [microgridId],
    pollingInterval: 1000 * 60 * 15,
  });

  return (
    <CardBox title="数据总览">
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%', rowGap: 16 }}>
        <div className={styles.middleRow}>
          <div className={styles.dataBox}>
            <img className={styles.leftIcon} src={RunStateImg}></img>
            <div>
              <div className={styles.valueRow}>
                <span className={styles.keyValue}>{data?.runDays ?? '--'}</span>
                <span className={styles.unit}>天</span>
              </div>
              <div className={styles.desc}>累计运行</div>
            </div>
          </div>
          <div className={styles.dataBox}>
            <img className={styles.leftIcon} src={CO2Img}></img>
            <div>
              <div className={styles.valueRow}>
                <span className={styles.keyValue}>{formatCarbon(data?.totalCarbonDioxideReduction).value}</span>
                <span className={styles.unit}>{formatCarbon(data?.totalCarbonDioxideReduction).unit}</span>
              </div>
              <div className={styles.desc}>累计二氧化碳减排</div>
            </div>
          </div>
        </div>
        <div className={styles.bottomRow}>
          <div className={styles.itemBox}>
            <div className={styles.title}>负载累计</div>
            <div className={styles.itemContent}>
              <div>
                <div className={`${styles.desc} ${styles.textCenter}`}>
                  用电量({formatPower(data?.loadTotalGeneration).unit})
                </div>
                <div style={{ marginBottom: 8 }} className={`${styles.keyValue} ${styles.textCenter}`}>
                  {formatPower(data?.loadTotalGeneration).value}
                </div>
              </div>
              <div>
                <div className={`${styles.desc} ${styles.textCenter}`}>
                  碳排总量(
                  {formatCarbonTotCO2(data?.loadTotalGeneration).unit})
                </div>
                <div className={`${styles.keyValue} ${styles.textCenter}`}>
                  {formatCarbonTotCO2(data?.loadTotalGeneration).value}
                </div>
              </div>
            </div>
          </div>
          <div className={styles.itemBox}>
            <div className={styles.title}>市电累计</div>
            <div className={styles.itemContent}>
              <div>
                <div className={`${styles.desc} ${styles.textCenter}`}>
                  上网电量({formatPower(data?.totalGridFeedIn).unit})
                </div>
                <div style={{ marginBottom: 8 }} className={`${styles.keyValue} ${styles.textCenter}`}>
                  {formatPower(data?.totalGridFeedIn).value}
                </div>
              </div>
              <div>
                <div className={`${styles.desc} ${styles.textCenter}`}>
                  下网电量({formatPower(data?.totalGridFeedIn).unit})
                </div>
                <div className={`${styles.keyValue} ${styles.textCenter}`}>
                  {formatPower(data?.totalGridPurchased).value}
                </div>
              </div>
            </div>
          </div>
          <div className={styles.itemBox}>
            <div className={styles.title}>储能累计</div>
            <div className={styles.itemContent}>
              <div>
                <div className={`${styles.desc} ${styles.textCenter}`}>
                  充电量({formatPower(data?.bsaTotalCharge).unit})
                </div>
                <div style={{ marginBottom: 8 }} className={`${styles.keyValue} ${styles.textCenter}`}>
                  {formatPower(data?.bsaTotalCharge).value}
                </div>
              </div>
              <div>
                <div className={`${styles.desc} ${styles.textCenter}`}>
                  放电量({formatPower(data?.pvTotalGeneration).unit})
                </div>
                <div className={`${styles.keyValue} ${styles.textCenter}`}>
                  {formatPower(data?.bsaTotalDisCharge).value}
                </div>
              </div>
            </div>
          </div>
          {!dataExit?.wpExists ? (
            <div className={styles.itemBox}>
              <div className={styles.title}>光伏累计</div>
              <div className={styles.itemContent}>
                <div>
                  <div className={`${styles.desc} ${styles.textCenter}`}>
                    发电量({formatPower(data?.pvTotalGeneration).unit})
                  </div>
                  <div style={{ marginBottom: 8 }} className={`${styles.keyValue} ${styles.textCenter}`}>
                    {formatPower(data?.pvTotalGeneration).value}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className={styles.rightBox}>
              <div className={styles.rightItemBox}>
                <div className={`${styles.desc} ${styles.textLeft}`}>光伏累计发电量</div>
                <div className={styles.valueRow}>
                  <span className={styles.keyValue}>{formatPower(data?.pvTotalGeneration).value}</span>
                  <span className={styles.unit}>{formatPower(data?.pvTotalGeneration).unit}</span>
                </div>
              </div>

              <div className={styles.rightItemBox}>
                <div className={`${styles.desc} ${styles.textLeft}`}>风电累计发电量</div>
                <div className={styles.valueRow}>
                  <span className={styles.keyValue}>{formatPower(data?.wpTotalGeneration).value}</span>
                  <span className={styles.unit}>{formatPower(data?.wpTotalGeneration).unit}</span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </CardBox>
  );
};

export default DataScreening;
